<div class="bp-modal mod-lg wrapper">
  <bp-modal-header
    [title]="'send_via' | translate: [selectedCryptocoin?.name, selectedNetwork?.name]"
    class="font-semibold">
    <a (click)="onBackButtonClick()" (keydown.enter)="onBackButtonClick()" [tabIndex]="0" left>
      {{ "back" | translate }}
    </a>
    <a (click)="onCancelButtonClick()" (keydown.enter)="onCancelButtonClick()" [tabIndex]="0" right>
      {{ "cancel" | translate }}
    </a>
  </bp-modal-header>
  <div class="bp-modal-body">
    <div class="bp-modal-body-section">
      <div class="bp-modal-description">
        <div class="description-title">
          {{ "send_warning_network_title" | translate }}
        </div>
        <div class="info-steps">
          {{ "send_warning_info_steps" | translate }}
        </div>
        <div class="steps">
          <div class="wallet-address-step">
            <img class="check-mark-step" src="assets/images/check-mark-filled.svg" />
            {{ "send_warning_wallet_address" | translate }}
          </div>

          @if (selectedNetwork?.destination_tag) {
            <div class="memo-step">
              <img class="check-mark-step" src="assets/images/check-mark-filled.svg" />
              {{
              memoText | capitalize
              }}
            </div>
          }

          <div class="network-step">
            <img class="check-mark-step" src="assets/images/check-mark-filled.svg" />
            {{ "send_warning_network_blockchain" | translate }}
          </div>
        </div>

        <div class="send_warning_scam_alert" (click)="trackingFacade.trackWarningLinkFraudsClicked()" [innerHTML]="warningScamsText"></div>

        <div class="warning-box">
          <div class="no-hyphens">{{ "send_warning_box" | translate }}</div>
        </div>
      </div>
      <button (click)="onConfirm()" class="btn btn-primary btn-lg mod-button-width" type="button">
        {{ "verification_browser_understand" | translate }}
      </button>
    </div>
  </div>
</div>
